import { Children, isValidElement, type ReactElement, type ReactNode } from "react";

export interface WizardSlots {
  stage?: ReactElement;
  entitiesStage?: ReactElement;
  primaryButton?: ReactElement;
  secondaryButtons: ReactElement[];
  tertiaryButtons: ReactElement[];
}

export interface WizardSlotComponentMap {
  Stage: unknown;
  EntitiesStage: unknown;
  PrimaryButton: unknown;
  SecondaryButton: unknown;
  TertiaryButton: unknown;
}

/**
 * Walk Wizard's direct children once, matching each child against the slot
 * component identities. Singleton slots (Stage, EntitiesStage, PrimaryButton)
 * take the last matching child; SecondaryButton and TertiaryButton collect into
 * arrays so a wizard can declare multiple of each.
 */
export function useWizardSlots(children: ReactNode, components: WizardSlotComponentMap): WizardSlots {
  const slots: WizardSlots = { secondaryButtons: [], tertiaryButtons: [] };

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) return;
    const type = child.type;

    if (type === components.Stage) slots.stage = child;
    else if (type === components.EntitiesStage) slots.entitiesStage = child;
    else if (type === components.PrimaryButton) slots.primaryButton = child;
    else if (type === components.SecondaryButton) slots.secondaryButtons.push(child);
    else if (type === components.TertiaryButton) slots.tertiaryButtons.push(child);
  });

  return slots;
}
